import { Typography, Box } from '@mui/material'
import { Loader } from '@progress/kendo-react-indicators'
import React from 'react'

const sx = {
  root: {
    pointerEvents: 'none',
  },
}

const LoadingMessage = ({ title }) => {

  return (
    <Box position="fixed" top={0} right={0} left={0} bottom={0} display="flex" sx={sx.root}>
      <Box margin="auto">
        <Box display="flex" justifyContent="center">
          <Loader type="converging-spinner" />
        </Box>
        <Box height={48} display="flex" alignItems="center">
          {title && <Typography align="center">{title}</Typography>}
        </Box>
      </Box>
    </Box>
  )
}

export default LoadingMessage
